﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class RoleClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiRolesGet();
    }
}
exports.RoleClient = RoleClient;
//# sourceMappingURL=RoleClient.js.map